import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import userManager from './userManager'
import { onLogin } from '.'

import { GoClock, GoPerson, GoSignOut } from 'react-icons/go'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  UncontrolledDropdown,
  Button,
} from 'reactstrap'
import { FaEdit } from 'react-icons/fa'

class AuthButton extends Component {
  onLogout = (event) => {
    event.preventDefault()
    userManager.signoutRedirect()
    userManager.removeUser() // removes the user data from sessionStorage
  }

  render() {
    if (this.props.user) {
      return (
        <Navbar color="light" light expand="md">
          <Nav className="ml-auto" navbar>
            <UncontrolledDropdown setActiveFromChild>
              <DropdownToggle tag="div" className="nav-link" caret>
                {this.props.user.profile.preferred_username}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  tag="a"
                  target="_blank"
                  href={`${window.REACT_APP_KEYCLOAK_URL}/realms/${window.REACT_APP_KEYCLOAK_REALM}/account/password?referrer=${window.REACT_APP_KEYCLOAK_CLIENTID}`}
                >
                  <FaEdit /> Edit
                </DropdownItem>
                <DropdownItem tag="div">
                  <GoClock /> Expire{' '}
                  {moment.unix(this.props.user.profile.exp).from()}
                </DropdownItem>
                <Link
                  to={{
                    pathname: '/',
                  }}
                >
                  <DropdownItem tag="div" onClick={this.onLogout}>
                    <GoSignOut /> Sign out{' '}
                  </DropdownItem>
                </Link>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Navbar>
      )
    } else {
      return (
        <Link to="/">
          <Button color="primary" onClick={onLogin}>
            <GoPerson style={{ verticalAlign: 'text-top' }} />
            Sign up
          </Button>
        </Link>
      )
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.oidc.user,
})
export default withRouter(connect(mapStateToProps)(AuthButton))
